import type { UserStore } from "../../../stores/user";
import type { AddressesStore } from "../../../stores/addresses";

const userStore: Partial<UserStore> = {
  user: {
    first_name: "John",
    last_name: "Doe",
    email: "developers@fooji.com",
    phone: "6466815300"
  },
  hasLoaded: true
};

const addressesStore: Partial<AddressesStore> = {
  addresses: [{
    id: 1,
    is_default: true,
    address1: "1234 Main St",
    zip: "12345",
    city: "Springfield",
    state: "IL",
    country: "US",
    latitude: 39.781721,
    longitude: -89.650148,
    address2: "Apt 101",
    note: "This is a multiline note.\nIt can be as long as you want.\nIt can even contain emojis! 🎉"
  }],
  mode: "view",
  hasLoaded: true
};

export default {
  userStore,
  addressesStore
};
